export function initCookieBanner() {
  $("#cookieAccept").off("click.abrahamCookies");
  $("#cookieAccept").on("click.abrahamCookies", function(e) {
    e.preventDefault();
    $(".banner--cookies").removeClass("open");
    localStorage.setItem("cookies", "accepted");
  });
}
